<div class="debug-call-state-card"
     [style.right.px]="position.x"
     [style.bottom.px]="position.y"
     (mousedown)="onMouseDown($event)"
     (window:mousemove)="onMouseMove($event)"
     (window:mouseup)="onMouseUp()">

    <div class="debug-card-title">
        <span class="debug-title-text">Call State</span>
        <span class="debug-call-count">{{ calls.length }} call{{ calls.length !== 1 ? 's' : '' }}</span>
    </div>

    <div *ngIf="calls.length === 0" class="debug-empty-state">
        No active calls
    </div>

    <div *ngFor="let call of calls; let i = index"
         class="debug-call-entry"
         [ngClass]="[stateClass(call), call.callId === activeCallId ? 'debug-call-active' : '']">

        <div class="debug-card-header">
            <div class="debug-header-title">
                <span class="debug-state-badge">{{ stateLabel(call) }}</span>
                <span class="debug-active-badge" *ngIf="call.callId === activeCallId">ACTIVE</span>
                <span class="debug-v2-badge" *ngIf="call.mainLeg?.entityIsV2 === false">V1</span>
                <span class="debug-v2-badge debug-v2" *ngIf="call.mainLeg?.entityIsV2 === true">V2</span>
            </div>
            <div class="debug-header-info">
                <span class="debug-label">callId:</span>
                <span class="debug-value">{{ call.callId || '-' }}</span>
            </div>
        </div>

        <div class="debug-routing-row">
            <div class="debug-item" *ngIf="call.calleeId">
                <span class="debug-label">callee:</span>
                <span class="debug-value">{{ call.calleeKind }}:{{ call.calleeId | slice:0:8 }}</span>
            </div>
            <div class="debug-item">
                <span class="debug-label">destination:</span>
                <span class="debug-value">{{ call.destinationKind || '-' }}:{{ (call.destinationId | slice:0:8) || '-' }}</span>
            </div>
        </div>

        <div class="debug-flags-row">
            <span class="debug-flag" [class.debug-flag-active]="isIncoming(call)">isIncoming</span>
            <span class="debug-flag" [class.debug-flag-active]="isOnHold(call)">isOnHold</span>
            <span class="debug-flag" [class.debug-flag-active]="isForwarding(call)">isForwarded</span>
            <span class="debug-flag" [class.debug-flag-active]="isOutgoing(call) || (isForwarding(call) && call.mainLeg?.status === 'outgoing')">isCalling</span>
            <span class="debug-flag" [class.debug-flag-active]="isSpeaking(call) || (isForwarding(call) && call.mainLeg?.status === 'speaking')">isSpeaking</span>
        </div>

        <div class="debug-legs-container">
            <!-- PIP Leg (Left) -->
            <div class="debug-leg-card debug-leg-pip" [ngClass]="{
                'debug-leg-active': call.pipLeg,
                'debug-leg-hold': call.pipLeg?.status === 'hold'
            }">
                <div class="debug-leg-header">
                    <span class="debug-leg-title">PIP</span>
                    <span class="debug-leg-status" *ngIf="call.pipLeg">{{ call.pipLeg.status }}</span>
                    <span class="debug-leg-status debug-leg-empty" *ngIf="!call.pipLeg">empty</span>
                </div>
                <div class="debug-leg-content" *ngIf="call.pipLeg">
                    <div class="debug-item">
                        <span class="debug-label">entity:</span>
                        <span class="debug-value">{{ call.pipLeg.entity.kind }}</span>
                    </div>
                    <div class="debug-entity-id">{{ call.pipLeg.entity.id || '-' }}</div>
                    <div class="debug-item">
                        <span class="debug-label">sessions:</span>
                        <span class="debug-value">{{ call.pipLeg.sessions.length || 0 }}</span>
                    </div>
                </div>
                <div class="debug-leg-content debug-leg-empty-content" *ngIf="!call.pipLeg">
                    <span>No active leg</span>
                </div>
            </div>

            <!-- Main Leg (Right) -->
            <div class="debug-leg-card debug-leg-main" [ngClass]="{
                'debug-leg-active': call.mainLeg,
                'debug-leg-speaking': call.mainLeg?.status === 'speaking',
                'debug-leg-outgoing': call.mainLeg?.status === 'outgoing'
            }">
                <div class="debug-leg-header">
                    <span class="debug-leg-title">MAIN</span>
                    <span class="debug-leg-status" *ngIf="call.mainLeg">{{ call.mainLeg.status }}</span>
                    <span class="debug-leg-status debug-leg-empty" *ngIf="!call.mainLeg">empty</span>
                </div>
                <div class="debug-leg-content" *ngIf="call.mainLeg">
                    <div class="debug-item">
                        <span class="debug-label">entity:</span>
                        <span class="debug-value">{{ call.mainLeg.entity.kind }}</span>
                    </div>
                    <div class="debug-entity-id">{{ call.mainLeg.entity.id || '-' }}</div>
                    <div class="debug-item">
                        <span class="debug-label">sessions:</span>
                        <span class="debug-value">{{ call.mainLeg.sessions.length || 0 }}</span>
                    </div>
                </div>
                <div class="debug-leg-content debug-leg-empty-content" *ngIf="!call.mainLeg">
                    <span>No active leg</span>
                </div>
            </div>
        </div>
    </div>
</div>
